"use client"

import { Truck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TruckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TruckIcon = component(Icon)({ as: Truck })
